export enum EPeriodSupport {
    Yearly = "yearly",
    Quarterly = "quarterly",
    Monthly = "monthly",
}

export const getSupportPeriod = (supportedMonthsCount: number): EPeriodSupport | null => {
    if (supportedMonthsCount > 12) {
        return EPeriodSupport.Yearly;
    } else if (12 >= supportedMonthsCount && supportedMonthsCount >= 4) {
        return EPeriodSupport.Quarterly;
    } else if (4 > supportedMonthsCount && supportedMonthsCount > 0) {
        return EPeriodSupport.Monthly;
    }
    return null;
};
